import * as React from 'react';
import { NavigationItemModel } from '../../Header.types';
import DesktopNavigationLink from '../DesktopNavigationLink/DesktopNavigationLink';
import S from './DesktopNavigation.styles';

export type DesktopNavigationProps = {
  items: NavigationItemModel[];
  productsVariant: 'A' | 'B';
  setShowDropdownOverlay: React.Dispatch<React.SetStateAction<boolean>>;
  translations: Record<string, string>;
};

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  items,
  productsVariant,
  setShowDropdownOverlay,
  translations,
}) => {
  const [activeNavId, setActiveNavId] = React.useState<string>('');

  return (
    <S.Nav
      aria-label="Desktop Navigation"
      onMouseLeave={() => {
        setActiveNavId('');
        setShowDropdownOverlay(false);

        const focusedEl = document.activeElement as HTMLDivElement;

        if (focusedEl) {
          focusedEl.blur();
        }
      }}
    >
      <S.NavList>
        {items &&
          items.map((item) => (
            <DesktopNavigationLink
              key={item.id}
              item={item}
              isActive={activeNavId === item.id}
              onHover={(id) => setActiveNavId(id)}
              productsVariant={productsVariant}
              setShowDropdownOverlay={setShowDropdownOverlay}
              translations={translations}
            />
          ))}
      </S.NavList>
    </S.Nav>
  );
};

export default DesktopNavigation;
